module.exports = {"returnTo":"Return To","authorNum":"Author. #","rmaDate":"RMA Date","reopen":"Reopen"}


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/rma/en.json
// module id = NAUj
// module chunks = 1